"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-pietro-in-gu": {
    "5bcec2ad": [{
      "hkey": "8b5beb5f",
      "slug": "barche-calonega",
      "name": "Barche-Calonega",
      "primary": true,
      "skipSearch": false
    }],
    "barche": [{
      "hkey": "8b5beb5f",
      "slug": "barche-calonega",
      "name": "Barche-Calonega",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5f912009": [{
      "hkey": "8b5beb5f",
      "slug": "barche-calonega",
      "name": "Barche-Calonega",
      "primary": true,
      "skipSearch": false
    }],
    "calonega": [{
      "hkey": "8b5beb5f",
      "slug": "barche-calonega",
      "name": "Barche-Calonega",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-pietro-in-gu"
    }],
    "f55eef68": [{
      "hkey": "78c99f5c",
      "slug": "san-pietro-in-gu",
      "name": "San Pietro in Gu",
      "primary": true,
      "skipSearch": false
    }],
    "fanfari": [{
      "hkey": "78c99f5c",
      "slug": "san-pietro-in-gu",
      "name": "San Pietro in Gu",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0bd35f85": [{
      "hkey": "78c99f5c",
      "slug": "san-pietro-in-gu",
      "name": "San Pietro in Gu",
      "primary": true,
      "skipSearch": false
    }],
    "go": [{
      "hkey": "78c99f5c",
      "slug": "san-pietro-in-gu",
      "name": "San Pietro in Gu",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5847e64b": [{
      "hkey": "78c99f5c",
      "slug": "san-pietro-in-gu",
      "name": "San Pietro in Gu",
      "primary": true,
      "skipSearch": false
    }],
    "vaticano": [{
      "hkey": "78c99f5c",
      "slug": "san-pietro-in-gu",
      "name": "San Pietro in Gu",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;